// Imitates the C# Systems.Collection.Generic.NullableComparer<T> class.
// For doing client-side equivalents of server-side OrderBy(...) or ThenBy(...) calls using nullable types.
// See http://labs.developerfusion.co.uk/SourceViewer/browse.aspx?assembly=SSCLI&namespace=System.Collections.Generic&type=NullableComparer
// See https://msdn.microsoft.com/en-us/library/azhsac5f(v=vs.110).aspx
export const NullableComparer = <T>(x : T | null, y : T | null) => {
    if (x !== null) {
        if (y !== null) {
            return x < y ? -1 : x > y ? 1 : 0;
        }
        return 1;
    }
    if (y !== null) {
        return -1;
    }
    return 0;
};


// WEBPACK FOOTER //
// ./lib/NullableComparer.ts